class AdpNotificationIconController {
  constructor() {
    this.name = 'adpNotificationIcon';
  }
}

export default AdpNotificationIconController;



// WEBPACK FOOTER //
// ./src/app/components/adpNotificationIcon/adpNotificationIcon.controller.js